/**
 * Validates if a value is an object.
 */
export function isObject(obj) {
    return obj && typeof obj === 'object' && obj.constructor === Object;
}
/**
 * Verify type of key and return either its matchingKey or itself
 */
export function matching(key) {
    return isObject(key) ? key.matchingKey : key;
}
export function getStatus(client) {
    // @ts-ignore, function exists but it is not part of JS SDK type definitions
    return client.__getStatus();
}
